import React from "react";
import { useTokenStore } from "../hooks/useTokenStore";
import { Navigate, Outlet } from "react-router-dom";

export const PrivateRoute = () => {
  const token = useTokenStore((s) => s.token);

  return token !== "" ? <Outlet /> : <Navigate to={"/login"} />;
};
